import { render, staticRenderFns } from "./CompanyLetterHead.vue?vue&type=template&id=04ba50cf&scoped=true"
import script from "./CompanyLetterHead.vue?vue&type=script&lang=js"
export * from "./CompanyLetterHead.vue?vue&type=script&lang=js"
import style0 from "./CompanyLetterHead.vue?vue&type=style&index=0&id=04ba50cf&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ba50cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04ba50cf')) {
      api.createRecord('04ba50cf', component.options)
    } else {
      api.reload('04ba50cf', component.options)
    }
    module.hot.accept("./CompanyLetterHead.vue?vue&type=template&id=04ba50cf&scoped=true", function () {
      api.rerender('04ba50cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CompanyLetterHead.vue"
export default component.exports